'use client'
import { cn } from '@/utils/twMerge'
import { PrismicLink } from '@prismicio/react'
import { useLocale } from '@/context/LocaleContext'
import type { NavbarProductsDropdownProps } from '@/types/navbarDropdown'
import NavbarDropdownIcon from '@/components/navbar/NavbarDropdownIcon'

const ProductsDropdownData = ({ data }: NavbarProductsDropdownProps) => {
  const locale = useLocale()

  return (
    <div className="dropdown-menu">
      <div className="container-fluid">
        <div className="dropdown-menu-wrapper">
          <div className="product-nav-content col-span-4">
            {data.product_text && <h4 className="mb-6">{data.product_text}</h4>}

            <div className="product-nav-content-items">
              {(data.product ?? []).map((item, index) => {
                const key = `i-${index}`
                return (
                  <PrismicLink field={item.link_url} key={key}>
                    <div className="product-nav-content-item">
                      <NavbarDropdownIcon field={item.icon} />

                      <div className="flex flex-col gap-1 lg:ml-1 1xl:ml-2">
                        <span
                          className={cn(
                            'relative block font-halyardDisplay text-sm font-medium !leading-[140%] tracking-[0.16px] lg:top-1 1xl:top-[2px] 1xl:text-base',
                            locale === 'en-us' && 'xl:whitespace-nowrap',
                          )}>
                          {item.link_title}

                          {item.is_new_item && (
                            <span className="ml-2 rounded bg-primary-green-85 px-2 py-1 text-xs font-medium">New</span>
                          )}
                        </span>
                      </div>
                    </div>
                  </PrismicLink>
                )
              })}
            </div>
          </div>

          <div className="risk-management-nav-content col-span-4">
            <div>
              {data.secureframe_defense_cmmc_text && <h4 className="mb-6">{data.secureframe_defense_cmmc_text}</h4>}

              <div className="risk-management-nav-content-items">
                {(data.secureframe_defense_cmmc ?? []).map((item, index) => {
                  const key = `i-${index}`
                  return (
                    <PrismicLink field={item.link_url} key={key}>
                      <div className="risk-management-nav-content-item">
                        <NavbarDropdownIcon field={item.icon} />

                        <div className="flex flex-col gap-1 lg:ml-1 1xl:ml-2">
                          <span
                            className={cn(
                              'relative block font-halyardDisplay text-sm font-medium !leading-[140%] tracking-[0.16px] lg:top-1 1xl:top-[2px] 1xl:text-base',
                              locale === 'en-us' && 'xl:whitespace-nowrap',
                            )}>
                            {item.link_title}
                          </span>
                        </div>
                      </div>
                    </PrismicLink>
                  )
                })}
              </div>
            </div>
          </div>

          <div className="vendor-security-reviews-nav-content col-span-6">
            <div>
              {data.vendor_security_reviews_text && <h4 className="mb-6">{data.vendor_security_reviews_text}</h4>}

              <div className="vendor-security-reviews-nav-content-items">
                {(data.vendor_security_reviews ?? []).map((item, index) => {
                  const key = `i-${index}`
                  return (
                    <PrismicLink field={item.link_url} key={key}>
                      <div className="vendor-security-reviews-nav-content-item">
                        <NavbarDropdownIcon field={item.icon} />

                        <div className="flex flex-col gap-1 lg:ml-1 1xl:ml-2">
                          <span
                            className={cn(
                              'relative block font-halyardDisplay text-sm font-medium !leading-[140%] tracking-[0.16px] lg:top-1 1xl:top-[2px] 1xl:text-base',
                            )}>
                            {item.link_title}
                          </span>
                        </div>
                      </div>
                    </PrismicLink>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductsDropdownData
